import { render, staticRenderFns } from "./naoPago.vue?vue&type=template&id=6dda92be&scoped=true&"
import script from "./naoPago.vue?vue&type=script&lang=js&"
export * from "./naoPago.vue?vue&type=script&lang=js&"
import style0 from "./naoPago.vue?vue&type=style&index=0&id=6dda92be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dda92be",
  null
  
)

export default component.exports